import React, { useState } from "react";
import { Collapse, Typography, Paper, IconButton, } from "@mui/material";
import {ExpandMore, ExpandLess, ChevronRight} from  '@mui/icons-material'
import "./FAQList.component.scss";

interface FAQListComponent {
  title?: string;
  children?: React.ReactNode;
}

export const FAQListComponent: React.FC<FAQListComponent> = ({
  children,
  title,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className='faq-wrapper w-100'>
      <Paper
        elevation={5}
        className='title-paper mt-3 list-box-shadow'
      >
        <Typography onClick={() => setIsOpen(!isOpen)}  className='d-flex justify-content-between align-items-center mw-100 faq-cursor-pointer faq-list-title-text'>
          <strong>{title}</strong>
          <IconButton>
            {isOpen ?<ExpandLess color='secondary'/> : <ExpandMore color='secondary'/> }
          </IconButton>
        </Typography>
        
        <Collapse in={isOpen} timeout={800} style={{ transitionDelay: ".1s" }}>
          <Paper square={true} className='children-paper rounded-bottom py-2 px-4 pe'>{children}</Paper>
        </Collapse>
      </Paper>
    </div>
  );
};
